import {Form} from "react-bootstrap";
import {useEffect, useState, useContext} from "react";
import Tabs from "common/components/Tabs";
import {TodayGuests} from "./today";
import {BookingManagement} from "./booking";
import {PriceManagement} from "./price";
import ModalDialog from "common/components/Modal";
import React from "react";
import AdminApi from "common/api";
import CustomDatePicker from "common/components/DatePicker";
import {format} from "date-fns";
import {AlertContext} from "context/AlertContext";

export function getReservationType(type) {
  switch (type) {
    case "daytime": return 1;
    case "nighttime": return 2;
    case "allDay": return 3;
  }
}

export default function PoolTab() {

  const api = new AdminApi();
  const {setShow, setToastMsg} = useContext(AlertContext);
  
  const [poolMenuShow, setPoolMenuShow] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmShowOpen, setConfirmShowOpen] = useState(false);
  const [holidayModalOpen, setHolidayModalOpen] = useState(false);

  const [stats, setStats] = useState(null);
  const [priceInfo, setPriceInfo] = useState(null);
  const [updatePrice, setUpdatePrice] = useState(false);
  const [poolInfo, setPoolInfo] = useState(null);
  const [holidayList, setHolidayList] = useState([]);
  const [selectedHolidays, setSelectedHolidays] = useState([]);
  const [pendingHolidayDates, setPendingHolidayDates] = useState([]);

  const today = new Date();
  const [poolExposureEnd, setPoolExposureEnd] = useState(today); // 수영장이 서비스 메뉴에서 미노출 될 날짜
  const [newHolidayDate, setNewHolidayDate] = useState(today); // 휴무 등록 날짜

  function fetchPoolData() {
    api.getPoolInfo()
      .then((res) => {
        if (res?.infos) {
          setPoolInfo(res.infos);
          setPriceInfo(res.infos.price);
          if (res.infos.exposureEndDate !== null) {
            setPoolExposureEnd(res.infos.exposureEndDate);
            setPoolMenuShow(false);
          } else setPoolMenuShow(true);
        } else setPriceInfo(null);
      })
  }

  function fetchStatsData() {
    api.getBookingStats()
      .then((res) => {
        if (res?.infos) {
          setStats(res.infos)
        } else setStats(null);
      })
  }

  useEffect(() => {
    fetchStatsData();
    const updateList = setInterval(() => {
      fetchStatsData();
    }, 60000)
    return () => {
      clearInterval(updateList);
    }
  }, [])
  
  function updatePoolExposure(date, showBool) {
    api.updatePoolInfo({
      exposureEndDate: date ? format(date, "yyyy-MM-dd") : null,
      closedDate: poolInfo?.closedDate
    })
      .then((res) => {
        if (res?.result === "ok") {
          setToastMsg("수정되었습니다");
          setPoolMenuShow(showBool);
          fetchPoolData();
        } else {
          setPoolExposureEnd(poolInfo.exposureEndDate ?? today);
          setToastMsg("실패하였습니다");
        }
        setShow(true);
      })
      .finally(() => {
        setConfirmOpen(false);
        setConfirmShowOpen(false);
      })
  }

  function fetchHolidayList() {
    api.getPoolHolidays()
      .then((res) => {
        if (res?.result === "ok" && Array.isArray(res?.infos)) {
          setHolidayList(res.infos);
        } else {
          setHolidayList([]);
        }
      });
  }

  async function addSelectedHolidays() {
    if (pendingHolidayDates.length === 0) {
      setToastMsg("등록할 휴무일을 선택해 주세요");
      setShow(true);
      return;
    }

    let successCount = 0;
    let failedCount = 0;
    for (const holidayDate of pendingHolidayDates) {
      // eslint-disable-next-line no-await-in-loop
      const res = await api.addPoolHoliday(holidayDate);
      if (res?.result === "ok") {
        successCount += 1;
      } else {
        failedCount += 1;
      }
    }

    if (successCount > 0 && failedCount === 0) {
      setToastMsg(`${successCount}건의 휴무일이 등록되었습니다`);
    } else if (successCount > 0) {
      setToastMsg(`${successCount}건 등록, ${failedCount}건 실패`);
    } else {
      setToastMsg("휴무일 등록에 실패했습니다");
    }
    setShow(true);
    setPendingHolidayDates([]);
    fetchHolidayList();
  }

  function togglePendingHolidayDate(date) {
    if (!date) return;
    const holidayDate = format(date, "yyyy-MM-dd");
    setNewHolidayDate(date);
    setPendingHolidayDates((prev) => {
      if (prev.includes(holidayDate)) {
        return prev.filter((d) => d !== holidayDate);
      }
      return [...prev, holidayDate].sort();
    });
  }

  function toggleHolidaySelection(holidayDate, checked) {
    if (checked) {
      setSelectedHolidays((prev) => [...prev, holidayDate]);
    } else {
      setSelectedHolidays((prev) => prev.filter((d) => d !== holidayDate));
    }
  }

  async function deleteSelectedHolidays() {
    if (selectedHolidays.length === 0) {
      setToastMsg("삭제할 휴무일을 선택해 주세요");
      setShow(true);
      return;
    }

    let hasFailed = false;
    for (const holidayDate of selectedHolidays) {
      // 순차 삭제로 실패 날짜를 분리 처리한다.
      // eslint-disable-next-line no-await-in-loop
      const res = await api.deletePoolHoliday(holidayDate);
      if (res?.result !== "ok") {
        hasFailed = true;
      }
    }

    if (hasFailed) {
      setToastMsg("일부 휴무일 삭제에 실패했습니다");
    } else {
      setToastMsg("선택한 휴무일이 삭제되었습니다");
    }
    setShow(true);
    setSelectedHolidays([]);
    fetchHolidayList();
  }

  useEffect(() => {
    fetchPoolData();
  }, [updatePrice])

  return (
    <div>
      <div className="current-status-box">
        <div className="pool-booking-status">
          <div>
            <h2>수영장 예약 현황</h2>
            <span>수영장 메뉴 노출여부</span>
            <Form.Check
              type={"checkbox"}
              id={`show`}
              label={`노출`}
              checked={poolMenuShow ?? false}
              onChange={(e) => {
                if (e.target.checked) setConfirmShowOpen(true);
              }}
            />
            <Form.Check
              type={"checkbox"}
              id={`hide`}
              label={`미노출`}
              checked={!!poolInfo?.exposureEndDate}
              onChange={(e) => {
                if (e.target.checked) setConfirmOpen(true);
              }}
            />
            {poolInfo?.exposureEndDate && !poolMenuShow &&
              <span className="pool-exposure-end-date">(노출 마지막날: {format(poolExposureEnd, "yyyy-MM-dd")})</span>}
          </div>

          <div className="closed-date">
            <button className="blue-btn" style={{width: "fit-content", padding: "0px 10px"}} onClick={() => {
              setHolidayModalOpen(true);
              setPendingHolidayDates([]);
              fetchHolidayList();
            }}>
              휴무 ({poolInfo?.closedDate ? format(poolInfo?.closedDate, "yyyy-MM-dd") : "없음"})
            </button>
          </div>

          <div style={{marginTop: -5}}>
            <div>
              <p className="bold">{stats ? stats.waitingCount?.toLocaleString() : 0}</p>
              <span className="text-grey">확정 대기중</span>
            </div>
            <div>
              <p className="bold">{stats ? stats.reservedCount?.toLocaleString() : 0}</p>
              <span className="text-grey">확정된 전체 예약</span>
            </div>
            <div>
              <p className="bold">{stats ? stats.cancelledCount?.toLocaleString() : 0}</p>
              <span className="text-grey">예약 취소</span>
            </div>
          </div>
        </div>
        <div className="today-booking-status">
          <h2>오늘의 예약 현황</h2>
          <div>
            <div>
              <span className="text-grey">총 예약 평상 수: {stats ? stats.todayBedCountTotal?.toLocaleString() : 0}</span>
              <p className="bold">{stats ? stats.todayBedCount?.toLocaleString() : 0}</p>
              <span className="text-grey">남은 평상</span>
            </div>
            <div>
              <span className="text-grey">총 예약 건 수: {stats ? stats.todayBookingCountTotal?.toLocaleString() : 0}</span>
              <p className="bold">{stats ? stats.todayBookingCount?.toLocaleString() : 0}</p>
              <span className="text-grey">남은 예약 건 수</span>
            </div>
            <div>
              <span className="text-grey">총 입장 인원: {stats ? stats.todayPeopleCountTotal?.toLocaleString() : 0}</span>
              <p className="bold">{stats ? stats.todayPeopleCount?.toLocaleString() : 0}</p>
              <span className="text-grey">남은 입장 인원</span>
            </div>
          </div>
        </div>
      </div>

      <Tabs
        tabNames={["오늘 입장", "예약 관리", "평상 및 입장권 가격"]}
        tabPages={[
          <TodayGuests priceInfo={priceInfo} updateDashboard={fetchStatsData}/>,
          <BookingManagement updateDashboard={fetchStatsData}/>,
          <PriceManagement
            initPrice={priceInfo}
            updatePrice={() => setUpdatePrice(!updatePrice)}
            initExp={poolInfo?.exposureEndDate}
          />
        ]}
      />

      <ModalDialog show={confirmShowOpen}
                   onHide={() => {
                     setConfirmShowOpen(false)
                   }}
                   btnText={"예"} secondBtnText={"아니요"}
                   hasTwoButtons
                   onOk={() => updatePoolExposure(null, true)}
                   onClickSecond={() => {
                     setConfirmShowOpen(false)
                   }}
      >
        <p style={{textAlign: 'center'}}>
          수영장 메뉴 미노출 설정을 초기화 하시겠습니까?
        </p>
      </ModalDialog>
      <ModalDialog show={confirmOpen}
                   onHide={() => {
                     setPoolExposureEnd(today);
                     setConfirmOpen(false)
                   }}
                   btnText={"예"} secondBtnText={"아니요"}
                   hasTwoButtons
                   onOk={() => updatePoolExposure(poolExposureEnd, false)}
                   onClickSecond={() => {
                     setPoolExposureEnd(today);
                     setConfirmOpen(false)
                   }}
      >
        <div className="flex-center" style={{marginBottom: 20}}>
          <CustomDatePicker value={poolExposureEnd} minDate={today}
                            onChange={(val) => setPoolExposureEnd(val)}/>
        </div>
        <p style={{textAlign: 'center'}}>
          해당 날짜부터 예약 불가 및 수영장 메뉴를 앱에서 미노출 시키겠습니까?<br/>
          "예" 하시면 설정하신 날짜의 24:00시부터 예약 불가 및 수영장이 메뉴에서 미노출 됩니다.
        </p>
      </ModalDialog>

      <ModalDialog show={holidayModalOpen}
                   onHide={() => {
                     setHolidayModalOpen(false);
                     setSelectedHolidays([]);
                     setPendingHolidayDates([]);
                   }}
                   title={"휴무관리"}
                   btnText={"닫기"} secondBtnText={"선택삭제"}
                   hasTwoButtons
                   onOk={() => {
                     setHolidayModalOpen(false);
                     setSelectedHolidays([]);
                     setPendingHolidayDates([]);
                   }}
                   onClickSecond={() => {
                     deleteSelectedHolidays();
                   }}
      >
        <div style={{marginBottom: 16}}>
          <p className="bold" style={{marginBottom: 8}}>휴무 날짜 선택(다중)</p>
          <div style={{display: "flex", justifyContent: "center"}}>
            <CustomDatePicker
              value={newHolidayDate}
              minDate={today}
              onChange={(val) => togglePendingHolidayDate(val)}
              inline
              dayClassName={(date) => {
                const dateStr = format(date, "yyyy-MM-dd");
                return pendingHolidayDates.includes(dateStr) ? "selected-holiday-day" : undefined;
              }}
            />
          </div>
          <div style={{marginTop: 10}}>
            {pendingHolidayDates.length === 0 ? (
              <span className="text-grey"></span>
            ) : (
              <span className="text-grey">선택됨: {pendingHolidayDates.join(", ")}</span>
            )}
          </div>
          <div className="flex-center" style={{gap: 8, marginTop: 10}}>
            <button className="blue-btn" onClick={addSelectedHolidays}>선택 날짜 일괄 등록</button>
            <button className="grey-btn" onClick={() => setPendingHolidayDates([])}>선택 초기화</button>
          </div>
        </div>

        <p className="bold" style={{marginBottom: 8}}>등록된 휴무 리스트</p>
        <div style={{maxHeight: 240, overflowY: "auto", border: "1px solid #eee", borderRadius: 8, padding: 12}}>
          {holidayList.length === 0 ? (
            <p className="text-grey" style={{margin: 0}}>등록된 휴무일이 없습니다.</p>
          ) : (
            holidayList.map((holidayDate) => (
              <Form.Check
                key={`holiday-${holidayDate}`}
                type={"checkbox"}
                id={`holiday-${holidayDate}`}
                label={holidayDate}
                checked={selectedHolidays.includes(holidayDate)}
                onChange={(e) => toggleHolidaySelection(holidayDate, e.target.checked)}
              />
            ))
          )}
        </div>
      </ModalDialog>
    </div>
  )
}

